import { campaignStates } from "../../../types/customers"
import { ICampaign } from "../types/sponsoredProducts"
import {
  buildProjectGroups as buildGroups,
  IProjectGroup as IGenericProjectGroup,
  IProjectGroupMetrics,
  UNASSIGNED_GROUP_ID,
  UNASSIGNED_GROUP_TITLE,
  formatGroupCurrency,
  formatGroupPercent,
  formatGroupRoas,
} from "../../../components/ProjectGroups/projectGroups.helper"

export type IProjectGroup = IGenericProjectGroup<ICampaign>
export type { IProjectGroupMetrics }
export {
  UNASSIGNED_GROUP_ID,
  UNASSIGNED_GROUP_TITLE,
  formatGroupCurrency,
  formatGroupPercent,
  formatGroupRoas,
}

export function buildProjectGroups(campaigns: ICampaign[]): IProjectGroup[] {
  return buildGroups(campaigns, {
    getProject: (campaign) => campaign.project,
    getSpend: (campaign) => campaign.totalSpend,
    getSales: (campaign) => campaign.totalSales,
    isActive: (campaign) => campaign.campaignStatus === campaignStates.ENABLED,
  })
}
